module.exports = __webpack_public_path__ + "static/media/wait-timer.b34c08b8.svg";